var OCS = OCS || {};
OCS.UI = OCS.UI || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.DynamicMap = new Class({
    Extends: OCS.WxBriefing.Classes.Panel,
    class_name: 'DynamicMap',
    events: {},
    link_icon_html: '<span class="sprite link-button sprite-link-icon right no_mobile" title="Link the panel"></span>',
    initialize: function (op) {
        this.bound_methods.on_mousedown_link_button = this.on_mousedown_link_button.bind(this);
        this.bound_methods.click_link_button = this.click_link_button.bind(this);
        this.bound_methods.on_map_linked = this.activate_link_icon.bind(this);
        this.bound_methods.on_map_unlinked = this.deactivate_link_icon.bind(this);
        var current_panel = this.parent(op);
        if (current_panel) {
            return current_panel;
        }

    },
    render: function () {
        this.populate_panel();

        //this.frame_changed(null, new Date().getTime());
    },
    frame_changed: function (ts) {
        var formatted = moment(ts).format('M/DD/YY h:mm A');
        if (this.popup) {
            this.popup.set_timestamp(formatted);
        } else {
            this.get_panel_obj().set_timestamp(formatted);
        }
    },
    populate_panel: function () {
        this.parent();
        this.add_content();

    },
    replace_radar_product_info: function (text) {
        var current_state = this.get_panel_obj().get_panel_url_state();
        var new_radar_product;
        if (current_state.hasOwnProperty('r')) {
            new_radar_product = current_state.r;
        }
        var meta_info = this.get_product_meta_info();
        if (!new_radar_product && meta_info && meta_info.r) {
            new_radar_product = meta_info.r;
        }
        if (new_radar_product) {
            text = text.split('"N0Q"').join('"' + new_radar_product + '"');
        }


        return text;
    },
    replace_radar_site_info: function (text) {
        var current_state = this.get_panel_obj().get_panel_url_state();
        // The following block of code is in place so that multiple radars can be 
        //      processed while not replacing other 4 digit identifiers such as weather forecast offices
        var newSite;
        if (current_state.hasOwnProperty('s')) {
            newSite = current_state.s;
        }
        var meta_info = this.get_product_meta_info();
        if (!newSite && meta_info && meta_info.s) {
            newSite = meta_info.s;
        }
        var site = OCS.Utilities.array_has_object_with_prop(OCS.Viewer.Config.default_radar_locations, {'id': newSite});


        if (typeof site === "undefined" || !site) {
            site = OCS.Utilities.array_has_object_with_prop(OCS.Viewer.Config.default_radar_locations, {'id': OCS.User.get_user_preference('radar')});
            newSite = site.id;
            if (current_state) {
                current_state.s = newSite.toUpperCase();
                meta_info.s = newSite.toUpperCase();
                this.set_product_meta_info(meta_info);
                this.update_url_state({state: current_state});
            }
        }

        // Split off of the radar element and the site property keying for either a 4 digit entry or {{radar}}
        var res = text.split(/(<radar[^>]*site=")([a-zA-Z]{4}|\{\{radar\}\})/g);

        // Grab the first 2 elements of the string and add them together to start the basis of our new string
        var start_str = res.shift();
        var next_str = res.shift();
        var new_array_str = [start_str];
        if (next_str) {
            new_array_str[0] += next_str;
        }

        // Get the end of the string, store it for later use.
        var end_str = res.pop();

        // For each result take the even results and add them to the array, thus removing what we are trying to replace
        res.each(function (string, index) {
            if (index % 2) { // Test that this is an even result, if so add it to the array
                new_array_str.push(string);
            }
        });

        // Add the end of the string to the array
        if (end_str) {
            new_array_str.push(end_str);
        }

        // Join everything using our replacement as the separator between array elements
        return new_array_str.join(newSite);

    },
    load_styles: function () {

    },
    add_content: function () {
        var product_content;
        var product = this.get_product();


        product_content = this.replace_radar_site_info(this.get_product_content(), this.options.container_selector.replace(this.options.panel_container_prefix, ''));

        product_content = this.replace_radar_product_info(product_content, this.options.container_selector.replace(this.options.panel_container_prefix, ''));

        product_content = OCS.WxBriefing.Live.UI.replace_url_template_text(product_content);
        product.set_product_content(product_content);
        var ops = {};

        // Activate the debug options if the document body has a class debug on it.
        if (document.id(document.body).hasClass('debug')) {
            ops.debug = true;
        }

        this.load_styles();

        // Allow for these values to be updated on update
        var viewer = new OCS.Viewer.Classes.Controller(this.options.container, ops);
        viewer.set_product(product.data());
        this.set_viewer(viewer);
        if (!this.popup) {
            this.init_link_button();
        }

        this.viewer.start(product.data());
        // viewer.ocsmap is not defined until after the panel is populated
        this.viewer.addEvent('timestamp_updated', this.frame_changed.bind(this));
        this.viewer.addEvent('map_linked',this.bound_methods.on_map_linked);
        this.viewer.addEvent('map_unlinked',this.bound_methods.on_map_unlinked);
        this.viewer.render();

        this.options.container.removeClass('empty');
    },
    get_event_selector: function () {
        return this.viewer.get_event_selector();
    },
    init_link_button: function () {
        if (!this.get_panel_obj().panel.getElement('.link-button')) {
            var icon = Elements.from(this.link_icon_html);
            var title_el = this.get_panel_obj().panel.getElement('.product_title');
            icon.inject(title_el, 'after');
            icon.addEvent('mousedown', this.bound_methods.on_mousedown_link_button);
            icon.addEvent('click', this.bound_methods.click_link_button);
        }
    },
    mouse_down_link_button: function (data, e) {
        e.stopPropagation();
    },
    click_link_button: function (event) {
        var el = event.target;
        if (el.hasClass('sprite-link-icon')) {
            this.viewer.link_map();
        } else if (el.hasClass('sprite-link-icon-activated')) {
            this.viewer.unlink_map();
            this.deactivate_link_icon();
        }
        event.stop();
    },
    activate_link_icon: function () {
        var icon = this.get_panel_obj().panel.getElement('span.link-button');
        if (icon.hasClass('sprite-link-icon')) {
            icon.removeClass('sprite-link-icon').addClass('sprite-link-icon-activated');
            OCS.WxBriefing.Live.UI.send_analytic_event({'category': 'Product', 'action': 'Link - ' + this.options.container_selector, 'entry_id': this.get_product_entry_id()});
        }
    },
    deactivate_link_icon: function () {
        var icon = this.get_panel_obj().panel.getElement('span.link-button');
        if (icon.hasClass('sprite-link-icon-activated')) {
            icon.removeClass('sprite-link-icon-activated').addClass('sprite-link-icon');
            OCS.WxBriefing.Live.UI.send_analytic_event({'category': 'Product', 'action': 'UnLink', 'entry_id': this.get_product_entry_id()});
        }
    },
    resize: function () {
        this.parent();
        if (this.viewer) {
            this.viewer.resize();
        }
    },
    set_product_meta_info: function (product_meta_info) {
        if (this.viewer) {
            this.viewer.update_product_options(product_meta_info);
        }
        this.parent(product_meta_info);
    },
    on_mousedown_link_button: function(event) {
        event.stop();
    },
    destroy: function () {
        var panel_obj = this.get_panel_obj();
        if (panel_obj && panel_obj.panel) {
            var icon = panel_obj.panel.getElement('span.link-button');
            if (icon) {
                icon.removeEvent('mousedown', this.bound_methods.on_mousedown_link_button);
                icon.removeEvent('click', this.bound_methods.click_link_button);
                icon.destroy();
            }
        }

        this.options.container.setStyle('background', null);
        var event_manager = new OCS.Classes.OCSEventManager();
        Object.each(this.events, function (event_key) {
            event_manager.unsubscribe(event_key);
        }.bind(this));
        if (this.viewer) {
            this.viewer.destroy();
        }
        this.parent();
    }
});
OCS.WxBriefing.Classes.DynamicMapMobile = new Class({
    Extends: OCS.WxBriefing.Classes.DynamicMap,
    init_link_button: function () {

    },
    click_link_button: function (e) {

    },
    activate_link_icon: function (icon) {

    },
    deactivate_link_icon: function (icon) {

    }
});